export default "__VITE_ASSET__WVRJ_z2y__"